import {useEffect, useState} from 'react';
import {useAuthStore} from '../store/authStore';

export function useOnboardingStep(stepId: string) {
  const {user, profile, updateOnboardingProgress} = useAuthStore();
  const [hasCompleted, setHasCompleted] = useState(false);

  useEffect(() => {
    if (profile?.onboarding?.steps?.[stepId]?.completed) {
      setHasCompleted(true);
    }
  }, [profile, stepId]);

  const markAsCompleted = async (stepId: string) => {
    // Only proceed if:
    // 1. We have a user
    // 2. The step hasn't been completed yet
    // 3. The step isn't already marked as completed in the profile
    if (!user?.uid || hasCompleted || profile?.onboarding?.steps?.[stepId]?.completed) {
      return;
    }

    try {
      await updateOnboardingProgress(user.uid, stepId, true);
      setHasCompleted(true);
    } catch (error) {
      console.error('Error updating onboarding progress:', error);
    }
  };

  return {hasCompleted, markAsCompleted};
}
